// @ts-nocheck
import React from 'react'

import {getGraphDayState} from '../utils/graphDay'


const GraphDayDetailsModal = ({details, onClose}) => {
  if (!details) return null

  const value = details.value || {}
  const state = getGraphDayState(value, details.dayStateOptions || {})
  const items = state.bsiItems || []
  const title = details.title || [
    details.wellName ? `Скважина ${details.wellName}` : 'Данные за день',
    details.monthLabel,
    details.day ? `${details.day} число` : '',
  ].filter(Boolean).join(', ')

  return (
    <div style={overlayStyle} onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose()
    }}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>{title}</h2>
          <button type="button" style={closeButtonStyle} onClick={onClose} aria-label="Закрыть">×</button>
        </div>

        <div style={contentStyle}>
          {items.length > 0 ? items.map((item, index) => (
            <div key={item.id || item.bsi || index} style={cardStyle}>
              <div style={cardTitleStyle}>Проходка {index + 1}</div>
              <Detail label="Глубина" value={formatDepth(item.depth)} />
              <Detail label="ППК" value={formatDepth(item.ppk)} />
              <Detail label="Степень" value={item.bsi_level?.name} />
              <Detail label="Начало спуска" value={formatDateTime(item.descent_start)} />
              <Detail label="Окончание спуска" value={formatDateTime(item.descent_end)} />
              <Detail label="Время спуска" value={item.descent_total} />
              <Detail label="Начало подъёма" value={formatDateTime(item.lift_start)} />
              <Detail label="Окончание подъёма" value={formatDateTime(item.lift_end)} />
              <Detail label="Время подъёма" value={item.lift_total} />
            </div>
          )) : (
            <div style={cardStyle}>
              <div style={cardTitleStyle}>{state.reason || getEntryTitle(state.kind)}</div>
              <Detail label="Глубина" value={formatDepth(state.maxDepth || value.depth)} />
              <Detail label="ФИО" value={value.fio} />
              <Detail label="Экипаж" value={value.equipage?.label || value.equipage?.name} />
              <Detail label="Интервал" value={value.interval} />
            </div>
          )}

          {value.ppk_limit?.depth && (
            <div style={infoStyle}>
              Подтверждённый ППК: {value.ppk_limit.depth} м
              {value.ppk_limit.commit_date ? `, утверждён ${value.ppk_limit.commit_date}` : ''}
            </div>
          )}
          {value.ppk_pending && (
            <div style={warningStyle}>
              Есть в сводке ППК, но акт не подтверждён
              {value.ppk_pending.depth ? `: ${value.ppk_pending.depth} м` : ''}
              {value.ppk_pending.date ? ` от ${value.ppk_pending.date}` : ''}
            </div>
          )}
          {value.repair_info && (
            <div style={infoStyle}>
              <b>Ручной ввод при ремонте БСИ</b>
              <div>{value.repair_info.comment || 'Причина ремонта не указана'}</div>
              <div>
                {value.repair_info.date_from || '—'} – {value.repair_info.date_to || 'по настоящее время'}
              </div>
            </div>
          )}
        </div>

        <div style={actionsStyle}>
          <button type="button" style={buttonStyle} onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  )
}

const Detail = ({label, value}) => (
  <div style={detailRowStyle}>
    <span style={detailLabelStyle}>{label}</span>
    <span>{value === null || value === undefined || value === '' ? '—' : value}</span>
  </div>
)

function getEntryTitle(kind) {
  if (kind === 'manual_planned' || kind === 'manual_outside_plan') return 'Ручной ввод'
  if (kind === 'no_pass') return 'Непроход'
  if (kind === 'ppk_pending') return 'Неподтверждённый ППК'
  return 'Информация за день'
}

function formatDepth(value) {
  const depth = Number(value || 0)
  return depth ? `${depth.toFixed(1)} м` : '—'
}

function formatDateTime(value) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  zIndex: 1600,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px',
  background: 'rgba(15, 23, 42, 0.42)',
}

const modalStyle = {
  width: '520px',
  maxWidth: '100%',
  maxHeight: 'calc(100vh - 32px)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid #98a2b3',
  borderRadius: '6px',
  background: '#ffffff',
  boxShadow: '0 18px 50px rgba(15, 23, 42, 0.24)',
}

const headerStyle = {
  minHeight: '52px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  padding: '0 16px',
  borderBottom: '1px solid #d0d5dd',
}

const titleStyle = {margin: 0, fontSize: '17px', lineHeight: 1.3}
const closeButtonStyle = {
  width: '32px',
  height: '32px',
  border: 0,
  background: 'transparent',
  fontSize: '25px',
  cursor: 'pointer',
}
const contentStyle = {padding: '14px 16px', overflowY: 'auto', display: 'grid', gap: '10px'}
const cardStyle = {padding: '10px 12px', border: '1px solid #d0d5dd', borderRadius: '5px', background: '#f8fafc'}
const cardTitleStyle = {marginBottom: '7px', fontWeight: 700}
const detailRowStyle = {display: 'grid', gridTemplateColumns: '145px minmax(0, 1fr)', gap: '8px', fontSize: '13px', lineHeight: 1.55}
const detailLabelStyle = {color: '#667085'}
const infoStyle = {padding: '9px 11px', border: '1px solid #b9d8ef', borderRadius: '5px', background: '#eef7ff', fontSize: '13px'}
const warningStyle = {padding: '9px 11px', border: '1px solid #f0c36d', borderRadius: '5px', background: '#fff8e5', color: '#b42318', fontWeight: 700, fontSize: '13px'}
const actionsStyle = {display: 'flex', justifyContent: 'flex-end', padding: '10px 16px', borderTop: '1px solid #d0d5dd'}
const buttonStyle = {height: '34px', padding: '0 14px', border: '1px solid #98a2b3', borderRadius: '5px', background: '#ffffff', cursor: 'pointer'}

export default GraphDayDetailsModal
